import { GearSix, X } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import ApiKeyTag from "./ApiKeyTag";
import RemoveIntegration from "./RemoveIntegration";

type IntegrationSettingsProps =
  | { type: "instantly"; workspaceName: string }
  | { type: "smartlead"; apiKey: string };

export default function IntegrationSettings(props: IntegrationSettingsProps) {
  const { type } = props;
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Popover : Drawer;
  const Trigger = isDesktop ? PopoverTrigger : DrawerTrigger;
  const Content = isDesktop ? PopoverContent : DrawerContent;

  return (
    <Component>
      <Trigger asChild>
        <Button variant="secondary-black" intent="iconOnly" size="sm">
          <GearSix />
        </Button>
      </Trigger>
      <Content className="lg:w-96" align="start">
        {isDesktop ? (
          <div className="p-4 flex items-center border-b border-b-black-200 justify-between">
            <h3 className="text-md-bold">
              <span className="capitalize">{type}</span> settings
            </h3>
            <PopoverClose>
              <X className="text-black-500 size-5" />
            </PopoverClose>
          </div>
        ) : (
          <DrawerTitle className="mb-8">
            <span className="capitalize">{type}</span> settings
          </DrawerTitle>
        )}

        <div className="flex flex-col gap-y-6 lg:p-4">
          {type === "instantly" ? (
            <div className="flex flex-col items-start gap-y-1.5">
              <span className="text-button-xs">Instantly workspace</span>

              <h4 className="p-4 border-black-200 border w-full rounded-3xl text-md-bold">
                {props.workspaceName}
              </h4>

              <p className="text-xs text-black-500">
                To change your selected workspace, you must disconnect this one.
              </p>
            </div>
          ) : (
            <div className="flex items-center gap-x-1.5 justify-between">
              <h4 className="text-button-xs">Smartlead API key</h4>
              <ApiKeyTag token={props.apiKey} />
            </div>
          )}

          <RemoveIntegration type={type} />
        </div>
      </Content>
    </Component>
  );
}
